import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AppComponent} from "../../../app.component";
import {FormControl, FormGroup} from "@angular/forms";
import {SharedDataService} from "../../../services/shared-data.service";

@Component({
  selector: 'app-share-link-popup',
  templateUrl: './share-link-popup.component.html',
  styleUrls: []
})
export class ShareLinkPopupComponent implements OnInit {
  @Input() application: AppComponent;
  @Input() payload: object;
  @Output() close = new EventEmitter<void>();
  @Output() success = new EventEmitter<void>();

  state: string = 'default';
  public componentForm: FormGroup = new FormGroup({});
  public shareInput: FormControl = new FormControl('');
  constructor(private sharedDataService: SharedDataService) { }

  ngOnInit(): void {
    this.componentForm.addControl('shareInput', this.shareInput);
    this.shareInput.setValue(this.payload['link']);
  }

  public copyLink(event: Event | void = null): void {
    if (event) {
      event.stopPropagation();
    }
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.shareInput.value;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.sharedDataService.pushNotification({ text: AppComponent.getLabel('link_copied'), type: 'success' })
    this.onNoClick()
  }

  public onNoClick(): void {
    //this.dialogRef.close({ isConfirmed: false });
    this.close.emit()
  }

}
